<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Job Categories" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-header">
                <div class="row justify-content-between gy-3">
                    <div class="col-lg-3">
                        <div class="search-box">
                            <input type="text" class="form-control search" placeholder="Search for job categories..." [(ngModel)]="searchTerm" (ngModelChange)="performSearch()">
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <div class="col-lg-auto">
                        <div ngbDropdown class="d-md-flex gap-2 flex-wrap">
                            <button class="btn btn-info add-btn"><i class="ri-add-fill me-1 align-bottom"></i> Add
                                Categories</button>
                            <button class="btn btn-danger"><i class="ri-filter-2-line me-1 align-bottom"></i>
                                Filters</button>
                            <button ngbDropdownToggle type="button" id="dropdownMenuLink1" data-bs-toggle="dropdown" aria-expanded="false" class="btn btn-soft-info arrow-none"><i class="ri-more-2-fill"></i></button>
                            <ul ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                <li><a class="dropdown-item" href="javascript:void(0);">All</a></li>
                                <li><a class="dropdown-item" href="javascript:void(0);">Last Week</a></li>
                                <li><a class="dropdown-item" href="javascript:void(0);">Last Month</a></li>
                                <li><a class="dropdown-item" href="javascript:void(0);">Last Year</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--end col-->
</div>
<!--end row-->

<div class="row row-cols-xxl-5 row-cols-lg-3 row-cols-md-2 row-cols-1">
    @for ( category of categories; track $index) {
    <div class="col">
        <div class="card">
            <div class="card-body text-center py-4">
                <lord-icon src="{{category.icon}}" trigger="hover" colors="primary:#405189" target="div" style="width:50px;height:50px"></lord-icon>
                <a href="javascript:void(0);" class="stretched-link">
                    <h5 class="mt-4">{{category.name}}</h5>
                </a>
                <p class="text-muted mb-0">{{category.position}} Position</p>
            </div>
        </div>
    </div>
    }
    <div id="elmLoader">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>

<div class="row d-none" id="loadmore">
    <div class="col-lg-12">
        <div class="text-center mb-3">
            <button class="btn btn-link text-success mt-2" id="loadmore"><i class="mdi mdi-loading mdi-spin fs-20 align-middle me-2"></i> Load More </button>
        </div>
    </div>
</div>